module.exports = __webpack_public_path__ + "img/banner.2594253a.jpg";